module.exports = __webpack_public_path__ + "img/ReferBanner.3903aa95.png";